import React, { useEffect } from 'react';
function AnnualReport() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=478973871';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="AnnualReport">
      <a href="https://online.flippingbook.com/view/478973871/" className="fbo-embed" data-fbo-id="42c07d8ae2" data-fbo-ratio="3:2" data-fbo-lightbox="yes" data-fbo-width="100%" data-fbo-height="auto" data-fbo-version="1" style={{ maxWidth: '100%' }}>
        2025-2026 ICC Annual Report
      </a>
    </div>
  );
}

export default AnnualReport;

